import React from "react";
import { Wrap } from "./styles";
import Heading from "../../components/Heading";
import Content from "../../components/Content";
import RedirectButton from "../RedirectButton";
import ContentCheekToCheek from "../../components/ContentCheekToCheek";
import i18next from "i18next";
import { Utils } from "@zanichelli/myz-react-utils";
import { S3_IMAGE_FOLDER } from "../../../constants/endpoint";

type Props = {
  email?: string | null;
  logged: boolean;
};

const Confirm: React.FC<Props> = ({ email, logged }) => {
  const renderContent = () => {
    const text = Utils.trans(i18next.t("newwotd.confirm.description"), {
      EMAIL: email ? email : "",
    });
    return (
      <div>
        <Heading
          title={i18next.t("newwotd.title")}
          subtitle={i18next.t("newwotd.confirm.subtitle")}
        />
        <div className="description">
          <Content>
            <div>
              <p dangerouslySetInnerHTML={Utils.manageMarkupContent(text)} />
              <RedirectButton logged={logged} />
            </div>
          </Content>
        </div>
      </div>
    );
  };

  return (
    <Wrap>
      <ContentCheekToCheek>
        {renderContent()}
        <img src={S3_IMAGE_FOLDER + "/wotd-confirm.svg"} alt="" />
      </ContentCheekToCheek>
    </Wrap>
  );
};

export default Confirm;
